<template>
  <div v-if="showAdminBoard" style="display: none"></div>
  <div class="container">
    <header class="jumbotron">
      <h3>Create 2FA</h3>
    </header>
    <p>
      <strong
        >Leia o QrCode ou clique no link para configurar o google
        authenticator</strong
      >
    </p>
    <p>
      <img :src="qrcode" />
    </p>
    <p>
      <a :href="urlotp">Clique aqui para abrir google authenticator</a>
    </p>
    <p>
      <strong>Após configurado insira a chave abaixo para validar</strong>
    </p>
    <Form @submit="handleCreate2FA" :validation-schema="schema">
      <div v-if="!successful">
        <div class="form-group">
          <label for="otp">OTP</label>
          <Field
            name="otp"
            type="text"
            class="form-control"
            v-model="user.otp"
          />
          <ErrorMessage name="otp" class="error-feedback" />
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            Validate
          </button>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import AuthService from "../services/auth.service";
import * as yup from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  name: "Profile",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    var schema = yup.object().shape({
      otp: yup
        .string()
        .required("OTP is required!")
        .min(6, "Must be 6 characters!")
        .max(6, "Must be 6 characters!"),
    });
    return {
      user: {
        otp: "",
      },
      qrcode: "",
      urlotp: "",
      loading: false,
      successful: false,
      schema,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser["roles"]) {
        return this.currentUser["roles"].includes("ROLE_ADMIN");
      }
      return false;
    },
  },
  mounted() {
    if (this.loggedIn) {
      AuthService.generate2fa().then(
        (data) => {
          this.urlotp = data.data.url;
          this.qrcode = data.data.qrcode;
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    }
    if (!this.currentUser) {
      this.$root.logOut();
    }
  },
  methods: {
    handleCreate2FA(user) {
      this.message = "";
      this.successful = false;
      this.loading = true;
      AuthService.validate(user).then(
        () => {
          this.$router.push("/profile");
        },
        (error) => {
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.successful = false;
          this.loading = false;
        }
      );
    },
  },
};
</script>